// @ts-ignore
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import translations from './translation';
import moment from 'moment';
import IState from '../core/models/IState';

let intl:any;
const mapStateToProps = (state: IState) => {
  let locale = state.preferences.language;
  let messages = translations[locale].messages;
  let intlProvider = new IntlProvider({ locale, messages });
  moment.locale(locale);
  intl = intlProvider.state.intl;
  return { locale, messages };
};

export function formatMessage(key: string, value?: object): string {
  try {
    let label: {
      [key: string]: any;
    } = {};
    label[key] = intl.formatMessage(
      {
        id: key
      },
      value
    );
    return label[key];
  } catch {
    return key; 
  }
}

export default connect(mapStateToProps)(IntlProvider)
